/* istanbul ignore file */
import PropTypes from 'prop-types'
import React from 'react'
import { MAP } from './constants'

export function withMap(BaseComponent, mapId = 'mapId') {
  const factory = (props) => <BaseComponent {...props} />

  class Container extends React.PureComponent {
    static propTypes = {
      containerElement: PropTypes.node.isRequired,
      mapElement: PropTypes.node.isRequired,
    }

    static childContextTypes = {
      [MAP]: PropTypes.object,
    }

    state = {
      map: null,
    }

    getChildContext() {
      return {
        [MAP]: this.state.map,
      }
    }

    handleComponentMount(node) {
      if (this.state.map || node === null) {
        return
      }
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(node, {
        mapId,
      })
      this.setState({ map })
    }
    handleComponentMount = this.handleComponentMount.bind(this)

    render() {
      const { containerElement, mapElement, ...restProps } = this.props

      const { map } = this.state

      if (map) {
        return React.cloneElement(
          containerElement,
          {},
          React.cloneElement(mapElement, {
            ref: this.handleComponentMount,
          }),
          <div>{factory(restProps)}</div>
        )
      } else {
        return React.cloneElement(
          containerElement,
          {},
          React.cloneElement(mapElement, {
            ref: this.handleComponentMount,
          }),
          <div />
        )
      }
    }
  }

  return Container
}

export default withMap
